import { Component, HostBinding, Input } from '@angular/core';
import { App, ConfiguredApp } from '../../../interfaces/app';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { IRestaurantInfo } from '../../../interfaces/restaurant';

@Component({
  selector: 'app-app-view',
  templateUrl: './app-view.component.html',
  styleUrls: ['./app-view.component.scss']
})
export class AppViewComponent {
  public restaurantNames: { [id: number]: string } = {};
  public icons = {
    info: faInfoCircle
  };
  public tooltipText = '';

  @Input() config: ConfiguredApp | null = null;
  @Input() app: App | null = null;
  @Input() set restaurants(restaurantsInfo: IRestaurantInfo[]) {
    this.restaurantNames = restaurantsInfo.reduce(
      (acc: { [id: number]: string }, r) => {
        acc[r.id] = r.name;
        return acc;
      },
      {},
    );
    this.buildTooltip();
  }

  @HostBinding('class.withIcon')
  get hasIcon(): boolean {
    return !!this.app?.url;
  }

  private get restaurantIds(): number[] {
    if (this.config?.restaurants?.ids.length) {
      return this.config.restaurants.ids;
    }
    return [];
  }

  private buildTooltip(): void {
    const ids = this.restaurantIds;
    this.tooltipText = ids
      .map(id => this.restaurantNames[id])
      .filter(Boolean)
      .join('\n');
  }

  public getFaviconUrl(link: string): string {
    const domain = new URL(link).origin;
    return `https://www.google.com/s2/favicons?sz=32&domain_url=${domain}`;
  }
}
